import { render, staticRenderFns } from "./ExternalEmbedValidation.vue?vue&type=template&id=580e8a7a&scoped=true&"
import script from "./ExternalEmbedValidation.vue?vue&type=script&lang=js&"
export * from "./ExternalEmbedValidation.vue?vue&type=script&lang=js&"
import style0 from "./ExternalEmbedValidation.vue?vue&type=style&index=0&id=580e8a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e8a7a",
  null
  
)

export default component.exports